import axios from 'axios';

export const baseURL = 'https://www.gorvodokanal.com/support_portal/';

const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

export default api;
